import React from 'react';

import NavigationDrawer from './NavigationDrawer';
import { useLocation, matchPath } from 'react-router-dom';
import { urlStructureWorkspace } from '../../routing/routingPaths';

export interface SmartNavigationDrawerProps {
  quickNavigation?: boolean;
}
// TODO: rename to WorkspaceNavigationDrawer or something I guess
export const SmartNavigationDrawer = React.memo(
  (props: SmartNavigationDrawerProps) => {
    const { quickNavigation } = props;
    const location = useLocation();
    const m = matchPath<{ workspaceId: string }>(
      location.pathname,
      urlStructureWorkspace
    );

    const onAdminCenterPath = matchPath<{ workspaceId: string }>(
      location.pathname,
      `${urlStructureWorkspace}/admin-center`
    );

    if (!m) {
      return null;
    }

    return (
      <>
        {!quickNavigation ? (
          <NavigationDrawer
            rootUrl={
              onAdminCenterPath
                ? `/workspace/${m.params.workspaceId}/admin-center/`
                : `/workspace/${m.params.workspaceId}/`
            }
            isAdmin={false}
            variant={onAdminCenterPath ? 'adminCenter' : 'workspace'}
          />
        ) : (
          <NavigationDrawer
            rootUrl={
              onAdminCenterPath
                ? `/workspace/${m.params.workspaceId}/admin-center/`
                : `/workspace/${m.params.workspaceId}/`
            }
            isAdmin={false}
            variant={'quickNavigation'}
          />
        )}
      </>
    );
  }
);
